import { createNode } from '@glueapp/graph-types';

export const IsNull = createNode({
    id: 'Is Null',
    name: 'Is Null',
    description: 'Returns true if the input is null',
    aiDescription:
        'Checks whether a value is null. Connect any value to the "Input" port (generic); the "Output" port returns true if the value is null, false otherwise.',
    category: 'Comparison',
    color: '#a17ee2',
    integration: undefined,
    inPorts: {
        Input: { kind: 'generic', identifier: 'T' },
    },
    outPorts: {
        Output: { kind: 'boolean' },
    },
    execute: function (input) {
        return { output: { Output: input.inPorts.Input === null } };
    },
});
